module.exports = __webpack_public_path__ + "img/style_model_preview_676.820a2389.jpg";